<template>
  <ul ref="tab" class="sup-menu-frame">
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-how-to-register' }">
      <router-link class="sup-items-links" to="/page/sup-how-to-register">
        登録方法
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-how-to-login' }">
      <router-link class="sup-items-links" to="/page/sup-how-to-login">
        ログイン
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-payment-method' }">
      <router-link class="sup-items-links" to="/page/sup-payment-method">
        ご入出金
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-account-binding' }">
      <router-link class="sup-items-links" to="/page/sup-account-binding">
        出金アカウントの紐づけ方法
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-wallet' }">
      <router-link class="sup-items-links" to="/page/sup-wallet">
        ウォレットの紹介
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-event-bonus' }">
      <router-link class="sup-items-links" to="/page/sup-event-bonus">
        キャンペーンボーナス
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-about-shop' }">
      <router-link class="sup-items-links" to="/page/sup-about-shop">
        ショップについて
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-coupon' }">
      <router-link class="sup-items-links" to="/page/sup-coupon">
        クーポン
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-vip-class-upgrading' }">
      <router-link class="sup-items-links" to="/page/sup-vip-class-upgrading">
        VIPにアップグレードする方法
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-verify-your-account' }">
      <router-link class="sup-items-links" to="/page/sup-verify-your-account">
        本人確認方法
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-faq' }">
      <router-link class="sup-items-links" to="/page/sup-faq">
        よくある質問
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-responsible-gaming' }">
      <router-link class="sup-items-links" to="/page/sup-responsible-gaming">
        責任あるギャンブル
      </router-link>
    </li>
    <li class="sup-list" :class="{ 'active': $route.path === '/page/sup-recommended-games' }">
      <router-link class="sup-items-links" to="/page/sup-recommended-games">
        お勧めのゲーム
      </router-link>
    </li>
  </ul>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  computed: {
  },
  watch: {
    $route: {
      immediate: true,
      handler(to, from) {
        this.scrollToActive()
      }
    }
  },
  methods: {
    scrollToActive() {
      this.$nextTick(() => {
        setTimeout(() => {
          const container = this.$refs['tab']
          const activeItem = container.querySelector('.active')
          if (activeItem) {
            const containerRect = container.getBoundingClientRect()
            const activeItemRect = activeItem.getBoundingClientRect()

            let scrollPosition
            if (activeItem === container.lastElementChild) {
              scrollPosition = container.scrollWidth - container.clientWidth
            } else {
              scrollPosition = activeItemRect.left - containerRect.left + container.scrollLeft - (containerRect.width / 2) + (activeItemRect.width / 2)
            }

            container.scrollLeft = scrollPosition
          }
        }, 300)
      })
    }
  }
}
</script>
